import { Inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpHeaders } from '@angular/common/http';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const httpRequest = req.clone({
            headers: req.headers.append('Cache-Control', 'no-cache')
                .append('Pragma', 'no-cache')
                .append('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT')

        });

        return next.handle(httpRequest);
    }
}
